module.exports = __webpack_public_path__ + "media/music/punchy_bass_2-7385678a.mp3";